/** @format — Overdue document cards for shipment drawer */

import { AlertCircle } from "lucide-react";
import { formatUploadType } from "../utils/documentFormatters";
import EscalateBadge from "./EscalateBadge";
import type { AwaitingDocumentRow } from "../../shipments/hooks/useShipmentDocuments";

export default function DocumentsOverdueGrid({ items }: { items: AwaitingDocumentRow[] }) {
  const visible = items.filter((item) => !item.exists);

  if (visible.length === 0) {
    return <p className="py-12 text-center text-sm text-neutral-500">No documents in this tab.</p>;
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      {visible.map((item) => (
        <article
          key={item.uploadType}
          className="flex min-w-0 flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white"
        >
          <div className="flex aspect-[4/3] items-center justify-center bg-neutral-50">
            <AlertCircle className="h-5 w-5 text-red-600" strokeWidth={2} />
          </div>
          <div className="flex items-center justify-between gap-1 p-2">
            <p className="min-w-0 truncate text-xs font-medium text-[#0a0a0a]">
              {formatUploadType(item.uploadType)}
            </p>
            <EscalateBadge />
          </div>
        </article>
      ))}
    </div>
  );
}
